import cx from 'classnames';
import {useCallback, useMemo} from 'react';

import {OnlineStatusIcon} from 'components';
import {OnlineStatus} from 'types';
import {calculateUtils} from 'utils';

type Props = {
    initials: string | React.ReactElement;
    colorWord: string;
    size?: 'sm' | 'base' | 'lg';
    className?: string;
    colored?: boolean;
    onlineStatus?: OnlineStatus;
}

export const Initials: React.FC<Props> = (
    {initials, colorWord, size = 'base', className, colored = true, onlineStatus}: Props) => {
    const color = useMemo(() => colored ? calculateUtils.calculateColor(colorWord) : null, [colorWord, colored]);

    const renderInitials = useCallback(() => (
        <div
            className={cx(
                className,
                'tw-rounded-full tw-uppercase tw-text-alternative',
                'tw-flex tw-items-center tw-justify-center tw-bg-default',
                {
                    'tw-h-6 tw-w-6 tw-min-w-6 tw-text-xs': size === 'sm',
                    'tw-h-8 tw-w-8 tw-min-w-8 tw-text-sm': size === 'base',
                    'tw-h-10 tw-w-10 tw-min-w-10': size === 'lg',
                },
            )}
            {...(color && {style: {backgroundColor: color}})}
        >
            {initials}
        </div>
    ), [className, color, initials, size]);

    return (
        <div className='tw-relative tw-pl-0.5'>
            {onlineStatus &&
                <div className='tw-flex tw-absolute tw-bottom-0 tw-left-0'>
                    <OnlineStatusIcon
                        status={onlineStatus}
                        tooltip={false}
                        reverseAlign
                        size='md'
                        iconClassName='tw-border tw-border-light'
                    />
                </div>}
            {renderInitials()}
        </div>
    );
};

